import { Skeleton } from "@/shared/ui";

interface Props {
  isGoal?: boolean;
}

export default function TaskDetailSkeleton({ isGoal = false }: Props) {
  return (
    <div className="flex flex-col h-full">
      <div className="flex items-start justify-between gap-4 pb-4">
        <div className="flex-1 flex flex-col gap-2">
          <Skeleton height={24} width="70%" />
          <Skeleton height={20} width="40%" />
        </div>
        <div className="flex gap-1">
          <Skeleton width={36} height={36} />
          <Skeleton width={36} height={36} />
        </div>
      </div>

      <div className="border-t surface-base-stroke mb-5" />

      <div className="flex gap-6 flex-1">
        <div className="flex-1 flex flex-col gap-4">
          <Skeleton height={14} width={80} />
          <Skeleton height={60} />
          <div className="flex gap-4 mt-2">
            <Skeleton height={16} width={100} />
            <Skeleton height={16} width={80} />
          </div>
          <Skeleton height={80} />
          <Skeleton height={80} />
        </div>

        <div className="w-[284px] shrink-0">
          <div className="p-4 radius-lg border surface-component-stroke flex flex-col gap-4">
            {Array.from({ length: isGoal ? 3 : 6 }, (_, i) => (
              <div key={i} className="flex flex-col gap-1">
                <Skeleton height={12} width={80} />
                <Skeleton height={16} width={120} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
